import React, { useContext } from 'react'
import { checkPermission } from '../../../common/utils/methods/commonMethods/utilityMethod';
import ChangeProgramAction from '../commonQuickActions/ChangeProgramAction';
import { pages } from '../../../common/constant';
import { PermissionContext, RolePermissions } from '../../../../../../appContext';

const StudentInformationQuickActions = ({activeApplicationDetails, fetchApplications}) => {
  const batchDetailsPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["studentDashboardStudentInfo"]["id"]
  );

  return (
    <div className='d-flex flex-column align-items-start'>
      {checkPermission(batchDetailsPermissions, ['C', 'U']) && (
        <ChangeProgramAction
          activeApplicationDetails={activeApplicationDetails}
          fetchApplications={fetchApplications}
        />
      )}
    </div>
  );
}

export default StudentInformationQuickActions